<template>
    <div class="d-flex">
        <div class="left-side">
            <component 
                class="parallel landscape bottom-divider" 
                :announcement="this.announcements[0]"
                :refreshPeriod="this.refreshPeriod" 
                :isLandscape="true" 
                :isParallel="true"
                :is="returnComponent(0)"
                :isPreview="isPreview">
            </component>
            <component 
                class="parallel landscape" 
                :announcement="this.announcements[1]"
                :refreshPeriod="this.refreshPeriod" 
                :isLandscape="true" 
                :isParallel="true"
                :is="returnComponent(1)"
                :isPreview="isPreview">
            </component>
        </div>
        <div class="right-side">
            <component 
                class="parallel landscape bottom-divider" 
                :announcement="this.announcements[2]"
                :refreshPeriod="this.refreshPeriod" 
                :isLandscape="true" 
                :isParallel="true"
                :is="returnComponent(2)"
                :isPreview="isPreview">
            </component>
            <component 
                class="parallel landscape" 
                :announcement="this.announcements[3]"
                :refreshPeriod="this.refreshPeriod" 
                :isLandscape="true" 
                :isParallel="true"
                :is="returnComponent(3)"
                :isPreview="isPreview">
            </component>
        </div>
    </div>
</template>

<script>
    import BasicView from "../Templates/BasicView";
    import StudyDepartmentCallIn from "../Templates/StudyDepartmentCallIn";
    import EventPlanService from "../Templates/EventPlanService";
    import LessonPlanService from "../Templates/LessonPlanService";
    import FullScreenImageService from "../Templates/FullScreenImageService";
    import PublicTransportService from "../Templates/PublicTransportService";
    import FoodService from "../Templates/FoodService";

    export default {
        name: "ThreeParallels",

        props: {
            announcements: Array,
            refreshPeriod: Number,
            isPreview: Boolean
        },

        components: {
            BasicView,
            StudyDepartmentCallIn,
            EventPlanService,
            LessonPlanService,
            FullScreenImageService,
            PublicTransportService,
            FoodService
        },

        methods: {
            returnComponent(num) {
                return this.announcements[num].serviceName !== null ? this.announcements[num].serviceName : "BasicView";
            },

            computeBorder(side, announcement) {
                return (announcement.serviceName === 'FullScreenImageService') ? { [`border-${side}`]: '0.15vw solid white' } : {}
            }
        }
    }
</script>

<style scoped>
    .four-parallels {
        display: inline-block;
    }

    .left-side,
    .right-side
    {
        width: 50%;
    }

    .parallel {
        height: 50%;
    }
</style>
